import React from 'react'
import PropTypes from 'prop-types'
import Select from '../../../form/component/Select'


const ChangeTaskResponsible = ({ changeAssignedTo, taskReadOnly, task, updateAssignedToUserId, userWithRoleForTask, isTaskAdmin }) => {
    // only task admin are allowed to change
    // only show if the task is currently assigned to a user (as opposed to a role)
    // tasks assigned to partners cannot be changed
    // task can't be in status skipped or finished
    if (!isTaskAdmin || !task.assignedToUserId || task.partner || task.status === 'skipped' || task.status === 'finished') {
        return null
    }
    return (
        <tr>
            <td>New Responsible</td>
            <td>
                <Select
                    object={task}
                    name="assignedToUserId"
                    onChange={(name, value) => {
                        changeAssignedTo(name, value)
                        updateAssignedToUserId()
                    }}
                    valueList={userWithRoleForTask}
                    renderer={({ firstName, lastName }) => {
                        return firstName + ' ' + lastName
                    }}
                />
            </td>
        </tr>
    )
}

ChangeTaskResponsible.propTypes = {
    changeAssignedTo: PropTypes.func.isRequired,
    updateAssignedToUserId: PropTypes.func.isRequired,
    userWithRoleForTask: PropTypes.array.isRequired,
    isTaskAdmin: PropTypes.bool.isRequired,
    task: PropTypes.object.isRequired,
    taskReadOnly: PropTypes.bool.isRequired,
}


export default ChangeTaskResponsible



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/ChangeTaskResponsible.js